import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import LdsButton from "../../components/LdsButton";
import { SideBar } from "../../components/SideBar";
import { useSelector } from "react-redux";

import { ReactLoaderSpinner } from "../../components/ReactLoaderSpinner/index.js";
import scans from "../../assets/module-2/2-4-0-7-scans.png";
import LdsImage from "../../components/LdsImage";

// services
import { useBookmarkModuleMutation } from "../../store/services/moduleServerApi";

const Module_2_1_1 = () => {
  const { pathname: pathName } = useLocation();
  const { menuItems } = useSelector((state) => state?.moduleSlice);

  const [bookmarkModule, { isLoading: isMenuLoading }] =
    useBookmarkModuleMutation();

  /* Start useEffect */
  useEffect(() => {
    bookmarkModule({ pathName });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // * onPageLoad
  /* End useEffect */

  return (
    <div className="row">
      {isMenuLoading && <ReactLoaderSpinner />}
      {menuItems?.id && <SideBar menuItems={[menuItems]} />}
      <div className="col-sm-8">
        <main className="module-content">
          <section>
            <h1 className="blue text-uppercase b mt-5 mb-4">
              2.4.0 Semi-Independent Learning Through Practice Cases
            </h1>
            <p className="me-4">Estimated time to complete: 1 minute</p>
          </section>

          <section className="row justify-content-center text-lg-start text-sm-center align-items-center mt-4 mb-4">
            <div className="col-lg-8  col-md-12 d-flex gap-4 flex-lg-row flex-column align-items-center">
              <LdsImage
                src={scans}
                alt="An icon of a person undergoing a scan above the number 7, labeled 'Scans' in blue text."
                className="mb-sm-4"
                style={{ maxWidth: "188px" }}
              />
              <p className="h5 b dark-gray">
                You will now try reading 7 practice cases. A video explanation
                is provided for each case to guide you through the
                interpretation after you have conducted your initial read of the
                scan.
              </p>
            </div>
          </section>

          <section className="button-control">
            <LdsButton
              classes="white-button mt-3 mb-3 prev"
              onClick={function navClick() {
                window.open("/module-2/module-2-3-8", "_self");
              }}
            >
              Previous Lesson
            </LdsButton>
            <LdsButton
              classes="blue-button mt-3 mb-5 align-self-right float-end next"
              onClick={function navClick() {
                window.open("/module-2/module-2-4-1", "_self");
              }}
            >
              Next Lesson
            </LdsButton>
          </section>
        </main>
      </div>
    </div>
  );
};

export default Module_2_1_1;
